export default "__VITE_ASSET__BLsGiPSy__"